/* eslint-disable @typescript-eslint/typedef */
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { UserAddress } from '@lentau/address/shared/interfaces';
import * as actions from './address-mercury.actions';
import { AddressesApiService } from '../api/addresses-api.service';

@Injectable()
export class AddressesEffects {
  userMercuryAddressSearch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.userMercuryAddressSearch),
      switchMap(() =>
        this.addressesApiService.userMercuryAddressSearch().pipe(
          switchMap((addresses: UserAddress[]) => [actions.userMercuryAddressSearchSuccess({ addresses })]),
          catchError(() => of(actions.userMercuryAddressSearchFail()))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private addressesApiService: AddressesApiService
  ) {}
}
